var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDistanceToBush({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    fit: "",
    height: "100%",
    width: "100%",
    preserveAspectRatio: "xMidYMid meet",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8 8.9c-.5-.5-1.1-.9-1.8-1.2-.7-.3-1.4-.4-2.1-.4h-.2c-.8-1.2-2.2-2-3.8-2-2.5 0-4.5 2-4.5 4.5 0 .6.1 1.2.4 1.8-.9.8-1.4 2-1.4 3.2 0 2.5 2 4.5 4.5 4.5.5 0 1-.1 1.5-.3v4.3h2v-5.2c.5.1 1 .2 1.5.2.7 0 1.4-.1 2.1-.4.7-.3 1.3-.7 1.8-1.2s.9-1.1 1.2-1.8c.3-.7.4-1.4.4-2.1s-.1-1.4-.4-2.1c-.3-.7-.7-1.3-1.2-1.8zm4.4-2c-.2 1.2-.3 1.9-.4 2.3-.3 1.1-.7 1.2-.8.8-.3-.9.6-3.2-.7-5.6-1-1.9-2.7-3.2-5.2-4 1.2 1.2 1.8 2.7 1.8 4.4 0 .8-.3 1.4-.8 1.8.1 0 .2.1.4.1.8.3 1.5.8 2.1 1.4.6.6 1.1 1.3 1.4 2.1.3.8.5 1.6.5 2.5 0 .6-.1 1.3-.3 1.9 1.6-.9 2.7-2.7 2.7-4.7 0-1.4-.2-2.4-.7-3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m17.7 3-4-3v2H4V0L0 3l4 3V4h9.7v2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistanceToBush);
export default __webpack_public_path__ + "static/media/distance_to_bush.1d6fc82cca32cd393864613c1203ef2a.svg";
export { ForwardRef as ReactComponent };